import { useEffect, useState } from 'react';

const START_CLAIMS = 132_482;
const TICK_MS = 1100;
const MIN_BUMP = 1;
const MAX_BUMP = 17;

export function useLiveClaims(start = START_CLAIMS) {
  const [claims, setClaims] = useState(start);

  useEffect(() => {
    const id = window.setInterval(() => {
      const bump = MIN_BUMP + Math.floor(Math.random() * (MAX_BUMP - MIN_BUMP + 1));
      setClaims((prev) => prev + bump);
    }, TICK_MS);
    return () => window.clearInterval(id);
  }, []);

  return claims;
}

export function formatClaims(value: number): string {
  return `$${Math.round(value).toLocaleString('en-US')}`;
}
